// extracted by mini-css-extract-plugin
export var textInput = "_lt-0";